import { useTranslation } from 'react-i18next';
import { SEOMeta } from '../components/SEOMeta';
import { JsonLd } from '../components/JsonLd';
import { websiteSchema } from '../lib/jsonld';
import type { Lang } from '../lib/routes';
import {
  Hero,
  ValueProposition,
  Services,
  Challenges,
  Founder,
  BusinessModel,
  Lab,
  Compliance,
  BuyChannels,
  FinalCTA,
  Certifications,
} from "../components/sections/home";

export function Home() {
  const { t, i18n } = useTranslation('home');
  const lang: Lang = i18n.language === 'en' ? 'en' : 'fr';

  return (
    <>
      <SEOMeta title={t('meta.title')} description={t('meta.description')} />
      <JsonLd data={websiteSchema(lang)} />
      <Hero />
      <ValueProposition />
      <Services />
      {/* <KeyFigure /> */}
      <Challenges />
      <BusinessModel />
      <Lab />
      <Compliance />
      <Founder />
      <BuyChannels />
      <FinalCTA />
      <Certifications />
    </>
  );
}
